module.exports = __webpack_public_path__ + "static/media/产品优势-边缘计算网关.e6ed1670.jpg";